function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRemoveKeyboard = function SvgIconRemoveKeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#777",
    stroke: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.279 63.989H193.251c-20.346 0-39.7 8.82-53.054 24.186L4.314 244.473c-5.752 6.61-5.752 16.443 0 23.06l135.883 156.306a70.303 70.303 0 0 0 53.054 24.172h266.028c29.116 0 52.721-23.605 52.721-52.721V116.716c0-29.123-23.605-52.727-52.721-52.727zm-98.698 274.712-51.687-51.672-51.672 51.658-31.03-31.015 51.673-51.687L226.2 204.32l31.022-31.022 51.672 51.673 51.679-51.687 31.022 31.036-51.687 51.679 51.701 51.673-31.028 31.029z",
    style: {
      fill: "#777"
    }
  }));
};
export default SvgIconRemoveKeyboard;